import React from "react";
import SearchPanel from "../components/SearchPanel";

function Main({ menuVisible, toggleMenu }) {
    return (
        menuVisible && (
            <div className="fixed inset-0 z-[100] flex items-start justify-center pt-5 md:pt-20">
                <div 
                    onClick={toggleMenu} 
                    className="absolute inset-0"
                    style={{ backgroundColor: 'rgba(21, 17, 20, 0.6)' }}
                ></div>
                <div className="relative z-[101] w-full max-w-4xl px-5">
                    <SearchPanel onClose={toggleMenu} />
                </div>
            </div>
        )
    );
}

export default Main;